<template>
  <v-container class="mt-4 px-5" fluid>
    <v-card class="pa-3 shadowCard">
      <v-card-title primary-title>
        Mi aguinaldo
        <v-spacer></v-spacer>
        <!-- <v-btn 
          color="blue"
          tile
          @click="abrirFirma( )"
          v-if="!firma"
          dark
        > 
          Firmar documento
          <v-icon small right>mdi-pencil</v-icon>
        </v-btn> -->

        <v-alert
          dense
          text
          type="error"
          v-if="firma && firma.estatus == 2 "
        >
          Rechazado
        </v-alert>

        <v-alert
          dense
          text
          type="success"
          v-if="firma && firma.estatus == 1 "
        >
          Aceptado
        </v-alert>

        <v-alert
          dense
          text
          type="red"
          v-if="!firma"
        >
          Pendiente
        </v-alert>
      </v-card-title>

      <v-row dense>
        <v-col cols="12">
          <v-card class="mb-2 shadowCard">
            <v-card-title></v-card-title>

            <v-card-text class="black--text text-subtitle-1" v-if="aguinaldo">
              <b>Trabajador:</b> {{ getdatosUsuarioERPERP.nombre_completo }}<br/>
              <b>Puesto:</b> {{ format( aguinaldo.puesto ) }}<br/>
              <b>Fecha ingreso:</b> {{ format( aguinaldo.fecha_ingreso ) }}<br/>
              <b>Monto:</b> {{ format( aguinaldo.aguinaldo ) }}<br/><br/>

              <br/>

              <v-alert
                outlined
                type="error"
                prominent
                border="left"
              >
                ⚠️ Aviso Importante
                <br/>
                <br/>
                La información proporcionada a continuación es <b>confidencial</b> y de uso exclusivo para los fines establecidos. Está estrictamente prohibido su uso indebido, divulgación, reproducción, distribución, así como la captura y filtración de imágenes, capturas de pantalla (screenshots) o mensajes sin autorización expresa.
                <br/>
                <br/>

                En caso de que se detecte alguna violación a esta disposición, se aplicará una sanción de <b>2 millones de pesos</b>, conforme a los criterios establecidos en el reglamento correspondiente y, de ser necesario, con las acciones legales pertinentes.
                <br/>
                <br/>

                <b>Por favor, maneje esta información con la máxima discreción.</b>
              </v-alert>

              <v-alert
                v-if="!firma"
                outlined
                type="warning"
                prominent
                border="left"
              >
                Estimado(a)  {{ getdatosUsuarioERPERP.nombre_completo }}, <br/>
                El monto indicado en la parte superior será depositado en su cuenta. Le solicitamos, por favor, dar clic en el botón de aceptar para confirmar su conformidad con dicho monto.
                <br/>
                <br/><br/>
                Atentamente,<br/>
                School of english.
              </v-alert>
            </v-card-text>
            <!-- <v-divider></v-divider>
            <div>
              <canvas id="signature-pad" class="signature-pad" width="780" height="250"></canvas>
            </div> -->

            <v-card-text v-if="firma">
              <v-row>
                <v-col cols="7" v-for="(mensaje, i) in firma.comentarios" :key="i" :class="`${mensaje.id_trabajador != getdatosUsuarioERPERP.id_trabajador ? 'pl-10' : 'pr-10'}`">
                  <p 
                    :class="`pa-2 ma-0 mb-4 ${ mensaje.id_trabajador != getdatosUsuarioERPERP.id_trabajador ? 'mensajeIzq' : 'mensajeDer' }`">
                    {{ mensaje.motivo }}
                    <br/>
                    {{ mensaje.nombre_completo }}
                  </p>
                </v-col>
              </v-row>

            </v-card-text>

            <v-card-actions v-if="!firma || ( firma && firma.estatus == 0 )">
              <!-- <v-btn
                color="black"
                @click="dialogRechazo = true"        
                class="mr-2"
                tile
                dark
              >
                Rechazar
                <v-icon small right>mdi-close</v-icon>
              </v-btn> -->

              <v-btn
                color="green"
                @click="abrirFirma( )"        
                class="mr-2"
                tile
                dark
              >
                Acepto
                <v-icon small right>mdi-check</v-icon>
              </v-btn>

              <!-- <v-btn
                text
                color="primary"
                @click="limpiar()"
                small
              >
                <span v-if="this.$vuetify.breakpoint.name == 'xs'">
                  <v-icon color="primary">mdi-eraser</v-icon>
                </span>
                <span v-else>
                  Limpiar
                </span>
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card outlined class="mb-2">
        <v-card-title></v-card-title>
        <v-card-text class="black--text text-subtitle-1" v-if="aguinaldo">
          <b>Trabajador:</b> {{ getdatosUsuarioERPERP.nombre_completo }}<br/>
          <b>Puesto:</b> {{ format( aguinaldo.puesto ) }}<br/>
          <b>Fecha ingreso:</b> {{ format( aguinaldo.fecha_ingreso ) }}<br/>
          <b>Bono Navideño:</b> {{ format( aguinaldo.aguinaldo ) }}<br/><br/>
          <br/>

          <v-alert
            outlined
            type="warning"
            prominent
            border="left"
          >
            Aviso Importante
            <br/>
            <br/>
            Al confirmar su conformidad, usted acepta el monto indicado anteriormente. Posteriormente, se le asignará una cita exclusivamente para llevar a cabo la firma del documento correspondiente.
            <br/>
            <br/>

            Le recomendamos revisar cuidadosamente la información proporcionada, ya que durante su visita a corporativo no se realizarán aclaraciones adicionales sobre el monto.
            <br/>
            <br/>

            Agradecemos su comprensión y quedamos a su disposición para cualquier otra consulta previa a su aceptación.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>

        <v-card outlined>
          <label><b>Ingresa tu firma</b></label>
          <canvas id="signature-pad" width="750px" height="300"></canvas>
        </v-card>

        <v-card-text>
          <v-col cols="12">
            <label><b>Ingresa tu INE de lado de la firma</b></label>
            <div v-if="!file">
              <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                <div class="dropZone-info" @drag="onChange">
                  <span class="fa fa-cloud-upload dropZone-title"></span>
                  <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
                  <div class="dropZone-upload-limit-info">
                    <div>Extensión: png, jpg, jpeg, svg</div>
                    <div>Tamaño máximo: 10 MB</div>
                  </div>
                </div>
                <input type="file" @change="onChange">
              </div>
            </div>

            <!-- Botón para eliminar la imagen -->
            <!-- Mostrar la imagen -->
            <v-row v-if="vistaPrevia && vistaPrevia.length">
              <v-col cols="12" md="3" v-for="(img, i) in vistaPrevia" :key="i">
                <v-card class="py-4 shadowCard">
                  <v-img v-if="!img.video" :src="img.url" contain aspect-ratio="2"></v-img>
                  <video v-else :src="img.url" contain aspect-ratio="2" style="width: 100%; height: 100%;" class="d-flex"></video>
                  <v-btn  color="error"  small  @click="file = null, vistaPrevia = null, extension = ''" dark top right absolute fab >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>

          </v-col>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            @click="dialog = false"        
            small
            tile
            dark
          >
            Cancelar
            <v-icon small right>mdi-cancel</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            @click="savePNG( 1 )"        
            small
            class="mr-2"
            tile
            dark
          >
            Sí, acepto
            <v-icon small right>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRechazo"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card outlined class="mb-2">
        <v-card-title>Rechazar mi bono navideño</v-card-title>
        <v-card-text class="black--text">
          <label>Por favor, ingresar tu inconformidad a continuación.</label>
          <v-textarea
            label="motivo"
            v-model="motivo_rechazo"
            :rows="3"
            hide-details
            filled
            auto-grow
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            @click="dialogRechazo = false"        
            small
            tile
            dark
          >
            Cancelar
            <v-icon small right>mdi-cancel</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            @click="savePNG( 2 )"        
            small
            class="mr-2"
            tile
            dark
          >
            Enviar
            <v-icon small right>mdi-send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'

  import SignaturePad from 'signature_pad'


  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    data: () => ({
      signaturePad:null,

      descriptor: null,

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,

      firma: false,
      aguinaldo: null,
      dialogRechazo: false,
      motivo_rechazo: '',

      archivos:null,
      vistaPrevia: [],
      file: null,
      file2: '',
      vistaPrevia2: null,
      extension2:'',
      dragging: false,
      dragging2: false,
      dialgImagen:false,
      url_servidor: '',
      fullscreen: false,

    }),

    created( ) {
      this.initialize()
    },

    mounted () {
      // let canvas = document.getElementById('signature-pad');
      // this.signaturePad = new SignaturePad(canvas);
    },

    methods:{

      abrirFirma( ){
        this.dialog = true

        setTimeout(() => {
          let canvas = document.getElementById('signature-pad');
          this.signaturePad = new SignaturePad(canvas);
        }, 2000);

      },

      ver (pdf) {
        this.viewPdf = pdf
        this.dialog = true
        this.verElPdf = 'https://escuelakpi.club/manuales/reglamento.pdf'
      },

      initialize ( ) {
        this.cargar = true

        this.$http.get('aguinaldo.firma/' + this.getdatosUsuarioERPERP.id_trabajador).then(response=>{
          this.cargar       = false
          this.firma        = response.data.estatusFirma
          this.aguinaldo    = response.data.aguinaldo
        }).catch( error =>{ 
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })  
      },

      async savePNG ( estatus ){

        if(this.signaturePad.isEmpty()){
          return this.validarErrorDirecto('Necesitas ingresar una firma')
        }

        // CONVERTIR FIRMA EN IMAGEN
        let url = this.signaturePad.toDataURL();

        // Archivo blob binario
        let blobBin = atob(url.split(',')[1]);
        let array = [];
        // Recorremos el resultado
        for(let i = 0; i < blobBin.length; i++) {
          array.push(blobBin.charCodeAt(i));
        }

        // Convertimos a bloc
        const fileFirma = new Blob([new Uint8Array(array)], {type: 'image/png'});
        // Lo convertimos a archivo para poder agregarle una imagen
        const firmaArchivo = new File([fileFirma], "firma.png",{ type: "image/png" })


        let formData = new FormData();

        // Agregamos los archivos
        formData.append("file", this.file);
        formData.append("file", firmaArchivo);

        // Agregamos datos restantes
        formData.append("nombre"        , this.getdatosUsuarioERPERP.nombre_completo )
        formData.append("id_trabajador" , this.getdatosUsuarioERPERP.id_trabajador   )
        formData.append("aguinaldo"     , this.format( this.aguinaldo.aguinaldo )  )
        formData.append("puesto"        , this.aguinaldo.puesto  )
        formData.append("fecha_ingreso" , this.aguinaldo.fecha_ingreso  )
        formData.append("aguinaldo2"    , this.aguinaldo.aguinaldo  )
        formData.append("dias_aguinaldo", this.aguinaldo.dias_aguinaldo  )
        formData.append("sueldo_dia"    , this.aguinaldo.sueldo_dia  )
        formData.append("motivo_rechazo", this.motivo_rechazo )
        formData.append("firma"         , this.firma )
        formData.append("estatus"       , estatus )

        // agregamos el documento
        this.cargar = true

        // Guardamos el documento
        this.$http.post('crear-firma-bono/' + this.getdatosUsuarioERPERP.id_trabajador, formData).then(response=>{
          this.cargar = false
          // this.signaturePad.clear();
          this.dialog = false
          this.dialogRechazo = false
          this.motivo_rechazo = ''
          this.validarSuccess('Documento firmado correctamente')
          this.initialize( )
          // window.open(axios.defaults.baseURL + 'contratos/' + this.folio + '.pdf')
        }).catch(error=>{
          this.validarError(error.body.message)
        })
      },

      getBase64(file) {
        var me = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function () {
          let extension = file.name.split('.');
          me.vistaPrevia.push({
            url: reader.result,
            image_name: file.name,
            extension: extension[extension.length - 1],
            video: ['mp4', 'webm', 'ogg'].includes(extension[extension.length - 1].toLowerCase())
          });
        };
      },

      onChange(e) {
        var files = e.target.files || e.dataTransfer.files;

        if (!files.length) {
          this.dragging = false;
          return;
        }

        this.createFile(files[0]);
      },

      createFile(file) {
        if (file.size > 100000000000) {
          alert('please check file size no over 40 MB.')
          this.dragging = false;
          return;
        }

        let extension = file.name.split('.')

        this.file = file;
        this.extension = extension[extension.length - 1]
        this.getBase64(this.file)
        this.dragging = false;
      },


      limpiar (){
        this.signaturePad.clear();
      },

      validarError (mensaje) {
        this.error       = mensaje
        this.dialogError = true
      },

      openDialogSuccess ( mensaje ){
        this.successMensaje = mensaje
        this.dialogSuccess  = true
      },

      format( valor ){
        return valor.toLocaleString('es-MX', {
          style: 'currency',
          currency: 'MXN'
        });
      },
    },

    computed:{
      ...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

      tamanioPantalla () {
        return this.$vuetify.breakpoint.height -185
      },

      width(){
        return this.$vuetify.breakpoint.width
      },

      height(){
        return this.$vuetify.breakpoint.height - 250
      }
    }
  }
</script>

<style>
  body {
  margin: 0;
    font-family: sans-serif;
    font-size: 0.9rem;
  }
  #app {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  #toolbar {
    display: flex;
    align-items: center;
    background-color: #555;
    color: #fff;
    padding: 0.5em;
  }
  #toolbar button,
  #page-mode input {
    color: currentColor;
    background-color: transparent;
    font: inherit;
    border: 1px solid currentColor;
    border-radius: 3px;
    padding: 0.25em 0.5em;
  }
  #toolbar button:hover,
  #toolbar button:focus,
  #page-mode input:hover,
  #page-mode input:focus {
    color: lightGreen;
  }
  #page-mode {
    display: flex;
    align-items: center;
    padding: 0.25em 0.5em;
  }

  #viewport-container {
    flex: 1;
    background: #eee;
    overflow: auto;
  }


  #viewport {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  #viewport > div {
    text-align: center;
    max-width: 100%;
  }
  #viewport canvas {
    width: 100%;
    box-shadow: 0 2px 5px gray;
  }

  #viewerContainer::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .#viewerContainer > #viewerContainer::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  #viewerContainer::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  #viewerContainer::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 4px dashed red;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: red;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
  
</style>